<template>
  <div>
    <div align="center">
      <div class="Flex_Table pay_table" style="border: 1px solid black; font-size: 16px">
        <div class="Flex_Row" style="text-align: center">
          <div class="Flex_Cell">
            <h2>Transaction Status</h2>
            <hr />
          </div>
        </div>
        <div class="Flex_Row" style="text-align: left; border-bottom: dotted 1px gray">
          <div class="Flex_Cell" style="width: 40%">
            <span>Order No</span>
          </div>
          <div class="Flex_Cell" style="width: 2%">:</div>
          <div class="Flex_Cell" style="width: 58%">
            <span>{{ orderID }}</span>
          </div>
        </div>
        <div class="Flex_Row" style="text-align: left; border-bottom: dotted 1px gray">
          <div class="Flex_Cell" style="width: 40%">
            <span>Transaction Ref No.</span>
          </div>
          <div class="Flex_Cell" style="width: 2%">:</div>
          <div class="Flex_Cell" style="width: 58%">
            <span>{{ transRefNo }}</span>
          </div>
        </div>
        <div class="Flex_Row" style="text-align: left; border-bottom: dotted 1px gray">
          <div class="Flex_Cell" style="width: 40%">
            <span>Bank Ref No</span>
          </div>
          <div class="Flex_Cell" style="width: 2%">:</div>
          <div class="Flex_Cell" style="width: 58%">
            <span>{{ bankRefNo }}</span>
          </div>
        </div>
        <div class="Flex_Row" style="text-align: left; border-bottom: dotted 1px gray">
          <div class="Flex_Cell" style="width: 40%">
            <span>Amount</span>
          </div>
          <div class="Flex_Cell" style="width: 2%">:</div>
          <div class="Flex_Cell" style="width: 58%">
            <span>{{ paymentAmount }}</span>
          </div>
        </div>
        <div class="Flex_Row" style="text-align: left; border-bottom: dotted 1px gray">
          <div class="Flex_Cell" style="width: 40%">
            <span>Transaction Date & Time</span>
          </div>
          <div class="Flex_Cell" style="width: 2%">:</div>
          <div class="Flex_Cell" style="width: 58%">
            <span>{{ tranDate }}</span>
          </div>
        </div>
        <div class="Flex_Row" style="text-align: left; border-bottom: dotted 1px gray">
          <div class="Flex_Cell" style="width: 40%">
            <span>Transaction Status</span>
          </div>
          <div class="Flex_Cell" style="width: 2%">:</div>
          <div class="Flex_Cell" style="width: 58%">
            <span :class="transStatus">{{ transStatus }}</span>
          </div>
        </div>
        <div class="Flex_Row" style="text-align: left; border-bottom: dotted 1px gray">
          <div class="Flex_Cell" style="width: 40%">
            <span>Status Description</span>
          </div>
          <div class="Flex_Cell" style="width: 2%">:</div>
          <div class="Flex_Cell" style="width: 58%">
            <span :class="transStatus">{{ statusDesc }}</span>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div align="center">
      <div style="width: 80%">*Please noted the transaction ref number for future reference</div>
    </div>
    <br />
    <div align="center">
      <span style="width: 160px"></span>
      <input type="button" v-on:click="redirectToForm()" value="Redirect to Main Form" />
      <input type="button" value="Print Receipt" @click="printReceipt" v-if="false" />
    </div>
    <div v-if="isSuccess" style="color: red; margin-top: 0px; text-align: center">
      <img src="../assets/images/paysuccess.gif" class="status_img" />
    </div>
    <div v-if="isSuccess" align="center">
      <br />
      <h1 style="color: green">Payment Completed Successully !!</h1>
    </div>
    <div v-if="isError" style="color: red; margin-top: 0px; text-align: center">
      <img src="../assets/images/payerror.gif" class="status_img" />
    </div>
    <div v-if="isError" align="center">
      <br />
      <h1 style="color: Red">Payment Error !!</h1>
    </div>
  </div>
</template>
<style scoped>
.Success {
  color: green;
}

.Failed {
  color: red;
}

.pay_table {
  width: 40%;
}

.status_img {
  height: 13%;
  width: 13%;
}

@media screen and (max-width: 800px) {
  .pay_table {
    width: 60%;
  }

  .status_img {
    height: 23%;
    width: 23%;
  }
}

@media screen and (max-width: 480px) {
  .pay_table {
    width: 70%;
  }

  .status_img {
    height: 30%;
    width: 30%;
  }
}
</style>
<script>
import axios from "axios";
import config from "@/router/globalConfig";
import TransJS from "./servicesJS/Transaction.js";
export default {
  name: "TransResponse",
  data() {
    return {
      candidateID: "-1",
      orderID: "",
      transRefNo: "",
      paymentAmount: "",
      tranDate: "",
      transStatus: "",
      statusDesc: "",
      bankRefNo: "",
      isSuccess: false,
      isError: false,
      bookingID: -1,
      isTourOperatorPay: false
    };
  },
  methods: {
    getdata() {
      let _data_ = {
        orderID: this.orderID
      };
      TransJS.getTransSuccess(_data_, this.isTourOperatorPay).then(
        response => {
          // console.log(response.data.result);
          if (response.data.isSuccess) {
            // console.log();
            this.orderID = response.data.result.orderID;
            this.transRefNo = response.data.result.gatewayTransactionID;
            this.bankRefNo = response.data.result.bankRefNo;
            this.paymentAmount = response.data.result.paymentAmount;
            this.tranDate = response.data.result.paymentDate;
            this.transStatus =
              response.data.result.authZCode == "S" ? "Success" : "Failed";
            this.statusDesc = response.data.result.paymentMessage;
            this.isSuccess =
              response.data.result.payStatus == "1" ? true : false;
            this.isError = response.data.result.payStatus != "1" ? true : false;
            //this.isSuccess = true;
            //this.isError = true;
          } else {
            alert(response.data.msg);
          }
        },
        error => {
          if (error.response == undefined) {
            alert("Error: " + error);
          } else {
            alert("Error: " + error.response.statusText);
          }
        },
        failure => {
          alert("Failure: " + failure.response);
        }
      );
    },
    redirectToForm() {
      this.$root.$data.BookingID = this.bookingID;
      this.$root.$data.isSuccess = this.isSuccess;
      if (this.isTourOperatorPay) {
        this.$router.push({ name: "PaymentPortal" });
      } else {
        this.$router.push({ name: "TicketBooking" });
      }
    },
    printReceipt: function() {
      this.startMsg = "Please wait for report generation";
      var basicData = {
        BookingID: -1,
        AppNo: this.applicationNo,
        Type: 1,
        FileName: "Payment Receipt",
        FileFormat: "PDF",
        FileExtension: "pdf"
      };
      const _data_ = {
        BookingID: -1,
        type: 1
      };
      var url_ = config.WEB_API_PATH;

      url_ = url_ + "Receipt/PrintReceipt";
      axios
        .post(url_, "", {
          headers: {
            __RequestVerificationToken: config.AF_Token,
            Authorization: config.LOG_Token
          },
          params: _data_,
          crossdomain: true
        })
        .then(
          response => {
            this.reportPOPUp(response.data, basicData.FileExtension.toString());
          },
          error => {
            if (error.response == undefined) {
              alert("Error: " + error);
            } else {
              alert("Error: " + error.response.statusText);
            }
          },
          failure => {
            alert("Failure: " + failure);
          }
        );
    },
    reportPOPUp(data, ext) {
      var arg = data.split("|");
      if (arg[0] == "TRUE") {
        var base64Data = this.b64toBlob(arg[2]);
        if (window.saveAs) {
          window.saveAs(base64Data, fileName);
        } else if (navigator.SaveBlob) {
          navigator.SaveBlob(base64Data, fileName);
        } else if (navigator.msSaveBlob) {
          // For IE
          navigator.msSaveBlob(base64Data, fileName);
          this.startMsg = "Report generated";
        } else {
          // FOR FireFox & G Crome
          var fileName = arg[1];
          var linkSource = "data:application/" + ext + ";base64," + arg[2];
          var downloadLink = document.createElement("a");
          document.body.appendChild(downloadLink);
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          document.body.removeChild(downloadLink);
          this.startMsg = "Report generated";
        }
      } else {
        alert(arg[1]);
      }
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;
      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    }
  },
  mounted() {
    let me = this;
    me.orderID = me.$route.query.orderid;
    me.bookingID = me.$route.query.bookingID;
    me.isTourOperatorPay =
      me.$route.query.isTourOperatorPayment == "1" ? true : false;
    // me.getdata();
    window.setTimeout(function() {
      me.getdata();
    }, 500);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/TransResponse.vue